import {
  NotificationsActive,
  Inventory2Outlined,
  AssignmentOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import theme from "themeProvider";
import { toSafeString } from "./utils";

const BLUE = theme.palette.primary.main;
const ORANGE = theme.palette.orange.dark;
const GREEN = theme.palette.success.dark;

// Icon is keyed by eventSrc (who sent it).
const ICON_BY_EVENT_SRC = {
  NOTIFICATION: NotificationsActive,
  OMS: Inventory2Outlined,
  JOMS: AssignmentOutlined,
  CART: ShoppingCartOutlined,
};

// Color by source; ORDER/SHIPMENT event names override it (blue/green).
const COLOR_BY_EVENT_SRC = {
  NOTIFICATION: BLUE,
  OMS: GREEN,
  JOMS: GREEN,
  CART: ORANGE,
};

const COLOR_BY_EVENT_NAME_PREFIX = [
  { prefix: "ORDER", color: BLUE },
  { prefix: "SHIPMENT", color: GREEN },
];

// Legend entries, in display order.
export const EVENT_CATEGORIES = [
  { label: "ORDER", color: BLUE },
  { label: "SHIPMENT", color: GREEN },
  { label: "CART", color: ORANGE },
  { label: "NOTIFICATION", color: BLUE },
];

export const getEventIcon = (event) => {
  const src = toSafeString(event?.eventSrc || event?.eventSource).toUpperCase();
  const name = toSafeString(event?.eventName).toUpperCase();

  const Icon = ICON_BY_EVENT_SRC[src] || NotificationsActive;
  const namePrefixMatch = COLOR_BY_EVENT_NAME_PREFIX.find(({ prefix }) =>
    name.startsWith(prefix),
  );
  const color = namePrefixMatch?.color || COLOR_BY_EVENT_SRC[src] || BLUE;

  return { Icon, color };
};

// "SHIPMENT_DISPATCH" -> "Shipment Dispatch"; "" for missing/invalid names.
export const formatEventName = (name) =>
  toSafeString(name)
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((word) => word[0].toUpperCase() + word.slice(1))
    .join(" ");
